<template>
  <div class="base-foot-comp">
    <div :class="['company-detail', type == 1 ? 'default' : 'jus-center']">
      <div class="wrap-one">
        <div class="app-flex-mid">
          <img src="../../../assets/foot/logo.png" class="logo" />
          <div class="address-detail-cont">
            <div class="detail">公司地址：成都市天府新区伏龙北巷融创大厦1510</div>
            <div class="detail">联系方式：15928605977</div>
            <div class="detail">邮箱：schongbt@sina.com</div>
          </div>
        </div>
        <div class="opera-wrap app-flex-mid">
          <span @click="opera(2)">关于我们</span>
          <span @click="opera(1)">业务领域</span>
          <span @click="opera(3)">合作客户</span>
        </div>
      </div>

      <div :class="['wrap-two', type == 1 ? 'default' : 'up-top']">
        <img src="../../../assets/foot/wechat.png" class="wechat" />
        <div class="erweima">
          <span>扫一扫</span>
          <span>联系我们</span>
        </div>
      </div>
    </div>
    <div class="website-detail">Copyright 2021 HongBoTeng. All Rights Reserved</div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'BaseFoot',
  props: {
    // 默认 1：页脚为两端显示；为 2 时，则为微信图标在上部显示
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {}
  },
  methods: {
    ...mapActions(['navigateTo']),
    opera(idx) {
      let menuItem
      switch (idx) {
        case 1:
          menuItem = { id: 1, name: '业务领域', url: '/area' }
          break
        case 2:
          menuItem = { id: 2, name: '关于我们', url: '/about' }
          break
        case 3:
          menuItem = { id: 3, name: '合作客户', url: '/customer' }
          break
      }

      this.navigateTo({ $router: this.$router, parent: menuItem, isFoot: true })
    }
  }
}
</script>

<style lang="scss" scoped>
.base-foot-comp {
  .company-detail {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #000000;
    padding: 0px 250px;
    height: 272px;
    &.default {
      justify-content: space-between;
    }
    &.jus-center {
      justify-content: center;
    }
    .wrap-one {
      .logo {
        width: 223px;
        height: auto;
        background-color: #fff;
      }
      .address-detail-cont {
        margin-left: 50px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 28px;
        .detail {
          display: block;
          &:nth-child(2) {
            margin: 10px 0px;
          }
        }
      }
      .opera-wrap {
        width: 223px;
        justify-content: space-between;
        margin-top: 10px;
        span {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 22px;
          user-select: none;
          cursor: pointer;
        }
      }
    }
    .wrap-two {
      display: flex;
      user-select: none;
      &.default {
        align-items: center;
      }
      &.up-top {
        position: absolute;
        top: -138px;
        right: 40px;
        align-items: flex-end;
      }
      .wechat {
        width: 138px;
        height: 138px;
        background-color: #fff;
      }
      .erweima {
        margin-left: 23px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 28px;
        span {
          display: block;
          max-width: 80px;
        }
      }
    }
  }
  .website-detail {
    padding: 15px 0px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 22px;
    text-align: center;
  }
}
</style>
